import { graphql } from '#@/__gql__';

export const queryAuth = graphql(/* GraphQL */ `
  query AuthorizeMultiple($inputs: [AuthorizeInput]!) {
    authorizeMultiple(inputs: $inputs)
  }
`);
